<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Form Change History</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  
  <div *ngIf="auditFormItems.length == 0" class="alert alert-info">
    No Changes
  </div>

  <div *ngIf="auditFormItems.length > 0" class="table-responsive" style="max-height: 70vh; overflow-y: auto;">
    <table mat-table [dataSource]="auditFormItems" class="small">

      <ng-container matColumnDef="enquiry">
        <th mat-header-cell *matHeaderCellDef>Enquiry.</th>
        <td mat-cell *matCellDef="let item">{{item.enquiry}}</td>
      </ng-container>

      <ng-container matColumnDef="fieldName">
        <th mat-header-cell *matHeaderCellDef style="width: 100px">Field.</th>
        <td mat-cell *matCellDef="let item">{{item.fieldName}}</td>
      </ng-container>

      <ng-container matColumnDef="oldValue">
        <th mat-header-cell *matHeaderCellDef style="width: 160px">Old Value.</th>
        <td mat-cell *matCellDef="let item">{{item.oldValue}}</td>
      </ng-container>

      <ng-container matColumnDef="newValue">
        <th mat-header-cell *matHeaderCellDef style="width: 160px">New Value.</th>
        <td mat-cell *matCellDef="let item">{{item.newValue}}</td>
      </ng-container>

      <ng-container matColumnDef="byUser">
        <th mat-header-cell *matHeaderCellDef style="width: 120px">User.</th>
        <td mat-cell *matCellDef="let item">{{item.byUser}}</td>
      </ng-container>

      <ng-container matColumnDef="dateChanged">
        <th mat-header-cell *matHeaderCellDef style="width: 100px; padding-right: 0px;">Date Updated.</th>
        <td mat-cell *matCellDef="let item">{{item.dateChanged}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </div>

</div>